import { get, post, patch, del } from './apiHelper';

const ticketCustomizationService = {
    // Obtener personalización de tarjeta de una marca
    getCustomization: async (marcaId) => {
        try {
            const response = await get(`tickets/customization/${marcaId}`);
            
            // El backend devuelve { success: true, customization: { ... } }
            // Necesitamos extraer el objeto customization
            const customization = response?.customization || response;
            
            return customization;
        } catch (error) {
            console.error(`Error obteniendo personalización de tarjeta para marca ${marcaId}:`, error);
            throw error;
        }
    },

    // Crear personalización de tarjeta
    createCustomization: async (marcaId, customization) => {
        try {
            const response = await post(`tickets/customization/${marcaId}`, customization);
            
            // El backend puede devolver { success: true, customization: { ... } }
            // Extraer customization si existe, sino devolver la respuesta completa
            const result = response?.customization || response;
            
            return result;
        } catch (error) {
            console.error(`Error creando personalización de tarjeta para marca ${marcaId}:`, error);
            // Añadir más información al error
            if (error.response) {
                error.status = error.response.status;
                error.message = error.response.data?.message || error.message;
            }
            throw error;
        }
    },

    // Actualizar personalización de tarjeta
    updateCustomization: async (marcaId, customization) => {
        try {
            const response = await patch(`tickets/customization/${marcaId}`, customization);
            
            // El backend puede devolver { success: true, customization: { ... } }
            // Extraer customization si existe, sino devolver la respuesta completa
            const result = response?.customization || response;
            
            return result;
        } catch (error) {
            console.error(`Error actualizando personalización de tarjeta para marca ${marcaId}:`, error);
            // Añadir más información al error
            if (error.response) {
                error.status = error.response.status;
                error.message = error.response.data?.message || error.message;
            }
            throw error;
        }
    },

    // Eliminar personalización (reset a valores por defecto)
    deleteCustomization: async (marcaId) => {
        try {
            return await del(`tickets/customization/${marcaId}`);
        } catch (error) {
            console.error(`Error eliminando personalización de tarjeta para marca ${marcaId}:`, error);
            throw error;
        }
    },

    // Toggle activo/inactivo
    toggleActive: async (marcaId, isActive) => {
        try {
            return await patch(`tickets/customization/${marcaId}/toggle`, { isActive });
        } catch (error) {
            console.error(`Error cambiando estado de personalización de tarjeta para marca ${marcaId}:`, error);
            throw error;
        }
    },

    // Subir imagen hero para layout dark
    uploadHeroImage: async (marcaId, imageFile) => {
        try {
            const formData = new FormData();
            formData.append('heroImage', imageFile);

            // Usar fetch directamente para FormData con multipart/form-data
            const baseUrl = process.env.REACT_APP_BASE_API_URL || 'http://localhost:3000/api';
            const url = `${baseUrl}/tickets/customization/${marcaId}/hero-image`;

            const storedData = localStorage.getItem('auth-storage-petitprime');
            const token = storedData ? JSON.parse(storedData)?.state?.token : null;

            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Authorization': token ? `Bearer ${token}` : '',
                    // No establecer Content-Type, el navegador lo hará automáticamente con el boundary
                },
                body: formData
            });

            if (!response.ok) {
                const errorText = await response.text();
                throw new Error(`Error del servidor: ${response.status} - ${errorText}`);
            }

            return await response.json();
        } catch (error) {
            console.error(`Error subiendo imagen hero para marca ${marcaId}:`, error);
            throw error;
        }
    },

    // Eliminar imagen hero
    deleteHeroImage: async (marcaId) => {
        try {
            return await del(`tickets/customization/${marcaId}/hero-image`);
        } catch (error) {
            console.error(`Error eliminando imagen hero para marca ${marcaId}:`, error);
            throw error;
        }
    }
};

export default ticketCustomizationService;

